import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { useSelector } from "react-redux";
import Header from "../../components/header/header";

import "./outlet-detail.scss";
import Image from "../../components/image/image";
import Button from "../../components/button/button";
import Text from "../../components/text/text";
import BackIcon from "../../assets/backWhite.svg";
import Navbar from "../../components/navbar/navbar";
import OfferCard from "../../components/offer-card/offer-card";
import FoodImg from "../../assets/foodType.svg";
import TimeImg from "../../assets/time.svg";
import RupeeImg from "../../assets/rupee.svg";
import LocationImg from "../../assets/location.svg";
import DiningImg from "../../assets/type.svg";
import Tag from "../../components/tag/tag";
import Loader from "../../components/loader/loader";
import OfferPopUp from "../../components/offer-dialog/offer-dialog";

import GetDineInOutletDetailAPI from "../../services/GetDineInOutletsDetail/GetDineInOutletsDetail";

import { details } from "../../store/outletDetail/outletDetailSlice";

const OutletDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const walletReward = useSelector((state) => state.wallet.coins);

  const [outletDetail, setOutletDetail] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const [isOfferDetailOpen, setIsOfferDetailOpen] = useState(false);
  const [offerDetail, setOfferDetail] = useState({});
  const { outletId, outletNo } = location.state || {};

  useEffect(() => {
    getRestaurantDetail();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBack = () => {
    navigate("/explore");
  };

  const handlePayBill = () => {
    sessionStorage.setItem("payBillSource","explore")
    navigate("/pay-bill", {
      state: location?.state?.outletId,
    });
  };

  const getRestaurantDetail = async () => {
    let fetchedOutletId = outletId;
    let fetchedOutletNo = outletNo;

    if (!outletId && !outletNo) {
      const outletDetailsInfo = JSON.parse(localStorage.getItem("outletDetailsInfo"));
      fetchedOutletId = outletDetailsInfo?.outletId;
    }

    try {
      const responseData = await GetDineInOutletDetailAPI(
        {
          outletId: fetchedOutletId || undefined,
          outletNo: fetchedOutletNo || undefined,
        }
      );

      localStorage.setItem(
        "outletDetailsInfo",
        JSON.stringify(responseData[0])
      );
      setOutletDetail(responseData[0]);
      dispatch(details(responseData[0]));
      setIsLoader(false);
    } catch (error) {
      console.log("outlet detail---", error);
    }
  };

  const openOfferDetail = (offer) => {
    setOfferDetail(offer);
    setIsOfferDetailOpen(true);
  };

  const handleOfferClose = () => {
    setIsOfferDetailOpen(false);
  };

  return (
    <div className="restaurant-page">
      {isLoader && <Loader />}
      <div className="headerSection">
        <Header coin={walletReward} label={outletDetail?.outletName} onClick={handleBack}/>
      </div>
      <div className="rest-header">
        {outletDetail?.outletMedias?.length > 0 && (
          <Image
            src={outletDetail?.outletMedias[0]?.mediaPath}
            imgStyle="banner-img"
            isBanner
            alt="restaurant banner"
          />
        )}
        {/* <Image src={BackIcon} alt="" imgStyle="back-img" onClick={handleBack} /> */}
        <div className="rest-info">
          <div className="rest-name">{outletDetail?.outletName}</div>
          <div className="service">{outletDetail?.type}</div>
          <div className="location">{outletDetail?.locality}</div>
        </div>
      </div>
      <div className="nav-section">
        <Navbar />
      </div>
      <div className="deatil-content">
        <section id="offer" className="content-section">
          <span className="text-name">Offers</span>
          <div className="card-section">
            {/* {outletDetail?.outletOffers?.map((offer, index) => (
              offer.couponId > 0?
              <OfferCard
                key={index}
                discountType={offer?.discountType}
                offerAmt={offer?.discountValue}
                minOrderAmt={offer?.minOrderAmt}
                onClick={() => openOfferDetail(offer)}
              />
              : 
              <div className="inactive-offer-card">
                No Active Offers
              </div>
            ))} */}
            {outletDetail?.outletOffers?.length > 0 ? (
              outletDetail.outletOffers.map((offer, index) => (
                offer.couponId > 0 ? (
                  <OfferCard
                    key={index}
                    discountType={offer?.discountType}
                    offerAmt={offer?.discountValue}
                    minOrderAmt={offer?.minOrderAmt}
                    offerSelected={true}
                    onClick={() => openOfferDetail(offer)}
                  />
                ) : null
              ))
            ) : (
              <div className="inactive-offer-card">
                No Active Offers
              </div>
            )}
          </div>
        </section>
        <section id="photo" className="content-section">
          <span className="text-name">Photos</span>
          <div className="card-section">
            <PhotoProvider>
              {outletDetail?.outletMedias?.map((img, index) => (
                <PhotoView key={index} src={img?.mediaPath}>
                  <Image src={img?.mediaPath} imgStyle="menu-classname" />
                </PhotoView>
              ))}
            </PhotoProvider>
          </div>
        </section>
        <section id="menu" className="content-section">
          <span className="text-name">Menu</span>
          <div className="card-section">
            <PhotoProvider>
              {outletDetail?.outletMenu?.map((menu, index) => (
                <PhotoView key={index} src={menu?.mediaPath}>
                  <Image src={menu?.mediaPath} imgStyle="menu-classname" />
                </PhotoView>
              ))}
            </PhotoProvider>
          </div>
        </section>
        {outletDetail?.outletReviews?.length >= 1 && (
          <section id="review" className="content-section">
            <span className="text-name">Highlight</span>
            <div className="hightlights-section">
              {outletDetail?.highlights?.map((highlight, index) => (
                <span key={index}>
                  <Tag tagText={highlight} />
                </span>
              ))}
            </div>
            <div className="popular-section">
              <span className="text-name">Popular Dish</span>
              <div className="popular-dish-section">
                {outletDetail?.popularDishes?.map((dish, index) => (
                  <span key={index}>
                    <Tag tagText={dish} />
                  </span>
                ))}
              </div>
            </div>
          </section>
        )}
        <section id="about" className="content-section">
          <span className="text-name">
            About {outletDetail?.outletName} Restaurant
          </span>
          <div className="card-section about-section">
            <div className="about-item">
              <Image src={FoodImg} imgStyle="img-style" />
              <Text text={outletDetail?.description} styleText="text-style" />
            </div>
            <div className="about-item">
              <Image src={RupeeImg} imgStyle="img-style" />
              <Text text={outletDetail?.avgTowPrice} styleText="text-style" />
            </div>
            <div className="about-item">
              <Image src={LocationImg} imgStyle="img-style" />
              <Text text={outletDetail?.address} styleText="text-style" />
            </div>
            <div className="about-item">
              <Image src={TimeImg} imgStyle="img-style" />
              <Text text={outletDetail?.timings} styleText="text-style" />
            </div>
            <div className="about-item">
              <Image src={DiningImg} imgStyle="img-style" />
              <Text text={outletDetail?.type} styleText="text-style" />
            </div>
          </div>
        </section>
      </div>
      <div className="fixed-footer">
        <div className="btn-section">
          <Button
            btnText="Pay Bill"
            btnStyle="button-style"
            onClick={handlePayBill}
          />
        </div>
      </div>
      {isOfferDetailOpen && (
        <OfferPopUp
          isOpen={isOfferDetailOpen}
          handleModalClose={handleOfferClose}
          offerDetail={offerDetail}
        />
      )}
    </div>
  );
};

export default OutletDetail;
